/**
 * Indexer API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
package indexer.codegen

import kotlinx.serialization.Serializable
import kotlin.js.JsExport

/**
 *
 * @param id
 * @param sender
 * @param recipient
 * @param size
 * @param createdAt
 * @param createdAtHeight
 * @param symbol
 * @param type
 * @param transactionHash
 */
@JsExport
@Serializable
data class IndexerTransferResponseObject(

    val id: kotlin.String? = null,
    val sender: IndexerTransferResponseObjectSender? = null,
    val recipient: IndexerTransferResponseObjectSender? = null,
    val size: kotlin.String? = null,
    val createdAt: kotlin.String? = null,
    val createdAtHeight: kotlin.String? = null,
    val symbol: kotlin.String? = null,
    val type: IndexerTransferType? = null,
    val transactionHash: kotlin.String? = null
)
